import { render, staticRenderFns } from "./AnnextAndDisciplineDialog.vue?vue&type=template&id=0145a254&scoped=true&"
import script from "./AnnextAndDisciplineDialog.vue?vue&type=script&lang=js&"
export * from "./AnnextAndDisciplineDialog.vue?vue&type=script&lang=js&"
import style0 from "./AnnextAndDisciplineDialog.vue?vue&type=style&index=0&id=0145a254&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0145a254",
  null
  
)

export default component.exports